import React, { useEffect, useMemo } from 'react';
import BootstrapTable from 'react-bootstrap-table-next';
import paginationFactory, { PaginationProvider } from 'react-bootstrap-table2-paginator';
import { shallowEqual, useDispatch, useSelector } from 'react-redux';
import * as actions from '../../../_redux/bank-kurban/bankKurbanAction';
import * as uiHelpers from '../BankKurbanUIHelpers';

import {
    getHandlerTableChange,
    NoRecordsFoundMessage,
    PleaseWaitMessage,
    toastOption,
} from '../../../../../../_metronic/_helpers';

import * as columnFormatters from './column-formatters';
import { Pagination } from '../../../../../../_metronic/_partials/controls';
import { useBankKurbanUIContext } from '../BankKurbanUIContext';

import { toast } from 'react-toastify';
import { RoleChecker } from '../../../../../RoleChecker';

export function BankKurbanTable(props) {

    const bankKurbanUIContext = useBankKurbanUIContext();
    const bankKurbanUIProps = useMemo(() => {
        return {
            queryParams: bankKurbanUIContext.queryParams,
            setQueryParams: bankKurbanUIContext.setQueryParams,
            openProcessPage: bankKurbanUIContext.openProcessPage,
        };
    }, [bankKurbanUIContext]);

    const { currentState } = useSelector(
        (state) => ({ currentState: state.bankKurban }),
        shallowEqual,
    );

    const { totalCount, entities, listLoading, error } = currentState;

    if (error !== undefined) {
        toast.error(error, toastOption);
    }

    const dispatch = useDispatch();
    useEffect(() => {

        dispatch(actions.fetchBankKurban(bankKurbanUIProps.queryParams));
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [bankKurbanUIProps.queryParams, dispatch]);

    const allowed = RoleChecker("Download", "bank_import")

    // Table columns
    const columns = [
        {
            dataField: 'type',
            text: 'Tipe Donasi'
        },
        {
            dataField: 'channel.bank.name',
            text: 'Bank',
        },
        {
            dataField: 'channel.name',
            text: 'No Rekening',
            // formatter: (value, row) => {
            //     return `${value} ${row.channel.name}`;
            // },
        },
        {
            dataField: 'status',
            text: 'Status',
        },
        {
            dataField: 'created_at',
            text: 'Tanggal Import',
            formatter: columnFormatters.DateColumnFormatter,
        },
        {
            dataField: 'url_path',
            text: 'Download File',
            formatter: (cell, row) => {
                if (allowed)
                    return columnFormatters.DownloadFormatter(cell, row)
            },
        },
        {
            dataField: 'action',
            text: 'Actions',
            formatter: columnFormatters.ActionsColumnFormatter,
            formatExtraData: {
                openProcessPage: bankKurbanUIProps.openProcessPage,
                // openDeleteProductDialog: productsUIProps.openDeleteProductDialog,
            },
            classes: 'text-right pr-0',
            headerClasses: 'text-right pr-3',
            style: {
                minWidth: '100px',
            },
        },
    ];

    // Table pagination properties
    const paginationOptions = {
        custom: true,
        totalSize: totalCount,
        sizePerPageList: uiHelpers.sizePerPageList,
        sizePerPage: bankKurbanUIProps.queryParams.pageSize,
        page: bankKurbanUIProps.queryParams.pageNumber,
    };

    return (
        <>
            <PaginationProvider pagination={paginationFactory(paginationOptions)}>
                {({ paginationProps, paginationTableProps }) => {
                    return (
                        <Pagination isLoading={listLoading} paginationProps={paginationProps}>
                            <BootstrapTable
                                wrapperClasses="table-responsive"
                                classes="table table-head-custom table-vertical-center overflow-hidden"
                                bootstrap4
                                bordered={false}
                                remote
                                keyField="uuid"
                                data={entities === null ? [] : entities}
                                columns={columns}
                                // defaultSorted={uiHelpers.defaultSorted}
                                onTableChange={getHandlerTableChange(
                                    bankKurbanUIProps.setQueryParams,
                                )}
                                {...paginationTableProps}
                            >
                                <PleaseWaitMessage entities={entities} />
                                <NoRecordsFoundMessage entities={entities} />
                            </BootstrapTable>
                        </Pagination>
                    );
                }}
            </PaginationProvider>
        </>
    );
};
